import React from 'react';
import { FiBell, FiMoon, FiSun, FiTrendingUp } from 'react-icons/fi';
import { getTheme, setTheme as persistTheme } from '../helpers';

function Header({ theme, setTheme }) {
  const currentTheme = theme || getTheme();

  const toggleTheme = () => {
    if (!setTheme) return;
    setTheme((current) => {
      const next = current === 'dark' ? 'light' : 'dark';
      persistTheme(next);
      return next;
    });
  };

  return (
    <header className="app-shell-header">
      <div className="header-left">
        <div className="brand-mark" aria-hidden="true">
          <FiTrendingUp size={18} />
        </div>
        <div className="brand-text">
          <div className="brand-title">
            Trade Exchanger
          </div>
          <div className="brand-subtitle">Fast INR ⇄ USDT exchange</div>
        </div>
      </div>

      <div className="header-actions">
        <button type="button" className="theme-toggle" onClick={toggleTheme} aria-label="Toggle theme">
          {currentTheme === 'dark' ? <FiSun size={16} /> : <FiMoon size={16} />}
        </button>
      </div>
    </header>
  );
}

export default Header;

